import React from 'react';
import {connect} from "react-redux";
import '../style/detail.css';
import RewardDetailContainer from "./RewardDetailContainer";
import RewardClaimContainer from "./RewardClaimContainer";
import RewardClaimHistoryContainer from "./RewardClaimHistoryContainer";
import RewardTitleComponent from "../components/RewardTitleComponent";
import BackComponent from "../components/BackComponent";
import RewardGroupSwitchContainer from "./RewardGroupSwitchContainer";

class RewardDetailPage extends React.Component {

    componentWillMount() {
        this.props.rewardDetailPageMounted(this.props.match.params.friendlyName);
    }

    render() {
        // important to bind the div key to the friendly name
        // grouped rewards allow to toggle between rewards, in that case the components need to be rerendered to fetch new data
        return <div key={this.props.match.params.friendlyName}>
            <BackComponent/>
            <div className="row no-margin reward-detail-page" >
                <div className="col-sm-12 col-md-8 reward-detail">
                    <RewardTitleComponent key={'title_'+this.props.lang} friendlyName={this.props.match.params.friendlyName}/>
                    <RewardDetailContainer key={'detail_'+this.props.lang}/>
                </div>
                <div className="col-sm-12 col-md-4 reward-detail-actionpanel">
                    <RewardGroupSwitchContainer/>
                    <RewardClaimContainer key='claim' friendlyName={this.props.match.params.friendlyName}/>
                    <RewardClaimHistoryContainer key='claims' friendlyName={this.props.match.params.friendlyName}/>
                </div>
            </div>
        </div>;
    }

}

export default connect(
    (state) => {
        return {
            lang: state.language.currentLanguage,
            imageFetchId: state.reward.item ? state.reward.item.imageFetchId : null
        }
    },
    (dispatch) => {
        return {
            rewardDetailPageMounted: (friendlyName) => {
                dispatch({
                    type: 'REWARD_DETAIL_PAGE_MOUNTED',
                    friendlyName
                })
            }
        }
    }
)(RewardDetailPage)

